"use strict";
/**
 * Kushki file
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.KInfo = void 0;
const buffer_1 = require("buffer");
const PlatformCodeEnum_1 = require("./../lib/infrastructure/PlatformCodeEnum");
const UtilsService_1 = require("./../lib/service/UtilsService");
/**
 * Implementation
 */
class KInfo {
    static buildKushkiInfo(kushkiInfo) {
        const kushki_js_version = "1.39.8";
        if (kushkiInfo) {
            if (UtilsService_1.UtilsService.sIsEmpty(kushkiInfo.platformVersion))
                kushkiInfo.platformVersion = kushki_js_version;
            return KInfo._encodeKushkiInfo(kushkiInfo);
        }
        return KInfo._encodeKushkiInfo({
            platformId: PlatformCodeEnum_1.PlatformCodeEnum.KUSHKIJS,
            platformVersion: kushki_js_version,
        });
    }
    static _encodeKushkiInfo(kushkiInfo) {
        return buffer_1.Buffer.from(JSON.stringify(kushkiInfo)).toString("base64");
    }
}
exports.KInfo = KInfo;
